export default "__VITE_ASSET__97674edd__"